import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, dt, ROLE_LABEL } from "@/lib/api";
import { Panel } from "@/components/tam/ui";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function NotesPanel({ accountId }) {
  const [notes, setNotes] = useState([]);
  const [text, setText] = useState("");
  const load = useCallback(() => api.get(`/accounts/${accountId}/notes`).then((r) => setNotes(r.data)), [accountId]);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/accounts/${accountId}/notes`, { text });
      setText("");
      toast.success("Note added to audit trail");
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Panel title="Shared progress notes" testId="notes-panel"
      action={<span className="text-xs text-slate-500">Notes are permanent and cannot be edited or deleted</span>}>
      <form onSubmit={add} className="space-y-3 mb-6">
        <Textarea required rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a progress note for the team…" data-testid="note-input" />
        <Button type="submit" className="bg-[#0B132B] hover:bg-[#1c2647]" data-testid="note-submit-btn">Add note</Button>
      </form>
      {notes.length === 0 && <p className="text-sm text-slate-500" data-testid="notes-empty">No notes yet.</p>}
      <ul className="space-y-3" data-testid="notes-list">
        {notes.map((n) => (
          <li key={n.id} className="border border-slate-200 rounded-md p-4 bg-slate-50/60" data-testid={`note-item-${n.id}`}>
            <p className="text-sm whitespace-pre-wrap">{n.text}</p>
            <p className="text-xs text-slate-500 mt-2 font-mono">{n.user_name} ({ROLE_LABEL[n.user_role]}) · {dt(n.created_at)}</p>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
